import { object } from 'prop-types';

const CategoryServerPropTypes = {
    category: object
};

const CategoryClientPropTypes = {
    category: object
};

export {
    CategoryServerPropTypes,
    CategoryClientPropTypes
};
